import React, { ChangeEvent, FC } from 'react';
import { FooterLink } from '../../../../types/types';
import { FooterLinkModel } from '../../../../lib/shared-models/FooterLink.model';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import { windowService } from '../../../../utils/window.utils';

const LanguageSelector: FC<FooterLink> = (props) => {
  const model = new FooterLinkModel(props);

  const redirectToTargetUrl = (url): void => {
    const urlIsValid = !!model?.list?.find((item) => item?.fields?.link?.value?.href === url);

    if (urlIsValid) {
      windowService().location.assign(url);
    }
  };

  const onChange = (evt: ChangeEvent<HTMLSelectElement>): void => redirectToTargetUrl(evt?.target?.value);
  const options = Array.isArray(model?.list)
    ? model.list?.map((item) => (
        <option key={item?.id} value={item?.fields?.link?.value?.href}>
          {item?.fields?.link?.value?.text}
        </option>
      ))
    : null;

  return (
    <div className="language-selector">
      <Icon extraClassName="language-selector__left-icon" iconName="action-flag" size={iconSize.md} />
      <select className="language-selector__select" onChange={onChange}>
        {options}
      </select>
      <Icon extraClassName="language-selector__right-icon" iconName="arrow-chevron-down" size={iconSize.md} />
    </div>
  );
};

export default LanguageSelector;
